// components/ProgressBar.js
"use client";
import React from "react";

/**
 * ProgressBar
 * Props:
 *  - percent: number (0-100)
 *  - height (optional)
 *  - theme: { primary, accent } (optional)
 *
 * Pure Tailwind styling and inline style for dynamic width.
 */
export default function ProgressBar({ percent = 0, height = 8, theme = { primary: "#7c3aed", accent: "#06b6d4" } }) {
  const gradient = `linear-gradient(90deg, ${theme.primary}, ${theme.accent})`;
  return (
    <div className="w-full" dir="rtl" aria-hidden>
      <div className="w-full bg-slate-800/40 rounded-full overflow-hidden" style={{ height }}>
        <div
          className="h-full rounded-full transition-all duration-700 ease-out transform-gpu"
          style={{
            width: `${Math.max(0, Math.min(100, percent))}%`,
            background: gradient,
            boxShadow: "0 8px 30px rgba(124,58,237,0.12)",
          }}
        />
      </div>
    </div>
  );
}
